import { render, staticRenderFns } from "./freightTable.vue?vue&type=template&id=7e240754&scoped=true"
import script from "./freightTable.vue?vue&type=script&lang=js"
export * from "./freightTable.vue?vue&type=script&lang=js"
import style0 from "./freightTable.vue?vue&type=style&index=0&id=7e240754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e240754",
  null
  
)

export default component.exports